export default "__VITE_ASSET__C6qrB2O4__"